export const WorkData = [
  {
    id: 1,
    name: "The Kinnect App",
    description: `Kinnect is a Family Relationship Management platform.<br/>&nbsp; 
      ➔ Led and shipped Kinnect Checklist & Estate Modules & impoved Application performance by up to 15%.<br/>&nbsp; 
      ➔ Reduced the user-onboarding time upto 70% by implementing user guidance system.
      `,
    tags: ["Angular", "Typescript", "material-ui", "Ngrx", "React-native"],
    demo: "https://www.kinnect.us",
    github: "",
    img: "",
    side: true,
  },
  {
    id: 2,
    name: "Smart Apartment Data",
    description: `Smart apartment data is a wrapper library around mapbox-gl, 
    which uses open street maps and it is utilized by mapbox, maptiler, and other mapping services.<br/>&nbsp;
      ➔ Load pins on map, Zoom in/out.<br/>&nbsp;
      ➔ Filter Apartments & view Image slider.
      `,
    tags: ["Angular", "material-ui", "Ngrx", "Mapbox-gl", "firebase-hosting"],

    demo: "https://drive.google.com/file/d/1oiqzGQ4lXpCPXqO03ISinaHNkgPdUOgX/view?usp=sharing",
    github: "https://github.com/abhinavakhil/SmartAppartmentData",
    img: "",
    side: false,
  },
  {
    id: 3,
    name: "ZipHr Dashboard",
    description: `The dashboard provides you with a quick overview of critical information that you would likely want to know or review.<br/>&nbsp
      ➔ A clean list of posts, users and albums with filtering, sorting, and pagination.<br/>&nbsp;
    `,
    tags: ["Angular", "material-ui", "firebase-hosting"],

    demo: "https://machinechat-55af2.web.app/dashboard",
    github: "https://github.com/abhinavakhil/ZipHr-Dashboard",
    img: "",
    side: true,
  },
  {
    id: 4,
    name: "GeoTag",
    description: `GeoTag helps reduce waste effectively by geo-tracking the waste and triggering alerts and mapping the area with a high waste index.<br/>&nbsp;
      ➔ It was build at HackVisit3.0 under the sustainable development theme.<br/>&nbsp
      ➔ Category prize winner for best use of mapmyIndia Api.
      `,
    tags: [
      "Angular",
      "Bootstrap",
      "Microsoft-cognitive-vision-api",
      "MapmyIndia-api",
    ],

    demo: "https://drive.google.com/file/d/1-HgYqYuM_fFLaa4FsJC1NLSKTGp51PTf/view?usp=sharing",
    github: "https://github.com/abhinavakhil/GeoTag",
    img: "",
    side: false,
  },
  {
    id: 5,
    name: "Burger Builder",
    description: `The application uses all the new features introduced in EcmaScript 6. The application is a single page application with proper components and is Mobile Responsive.<br/>&nbsp 
    ➔ The Application also used proper authentication and from validation and implements routing uses React Router.;
      `,
    tags: ["React", "Bootstrap", "React-router", "Context-api"],

    demo: "https://react-burger-builder-cd4fb.web.app/",
    github: "https://github.com/abhinavakhil/Burger-Builder",
    img: "",
    side: true,
  },
  {
    id: 6,
    name: "Natours",
    description: `An awesome tour booking web platform where users can Manage booking, check
    tours map, check users’ reviews, ratings.<br/>&nbsp
    ➔ Includes features like authentication, authorization, security, credit card payment, emails.
      `,
    tags: [
      "Node js",
      "Express js",
      "Mongodb",
      "Mongodb Atlas",
      "Mapbox",
      "Heroku",
    ],

    demo: "https://www.natours.dev/",
    github: "https://github.com/abhinavakhil/Natours-nodejs",
    img: "",
    side: false,
  },

  // {
  //   id: 5,
  //   name: "Meme generator",
  //   description:
  //     "Web app which generate new MEME (with the help of meme api) with the custom input text",
  //   tags: ["react", "css", "meme-api"],

  //   demo: "/",
  //   github: "https://github.com/Abhirajmaid/Meme_generator",
  //   img: "https://images.unsplash.com/photo-1646713369588-add27cc47d77?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=327&q=80",
  //   side: true,
  // },
];
